/**
 * Client → portal-bug-report bot payload. Identity fields are stripped/ignored;
 * the bot reads the session profile.
 */
import { z } from 'zod';

export const MAX_BUG_SUMMARY_CHARS = 200;
export const MAX_BUG_DETAILS_CHARS = 8000;
/** Encoded JPEG payload cap (base64 characters, no data-URL prefix). */
export const MAX_JPEG_BASE64_CHARS = Math.floor(1.2 * 1024 * 1024);

const PAGE_PATH_RE = /^\/[^?#]*$/;

export const portalBugReportInputSchema = z
  .object({
    summary: z.string().trim().min(1).max(MAX_BUG_SUMMARY_CHARS),
    details: z.string().trim().min(1).max(MAX_BUG_DETAILS_CHARS),
    screenshotBase64: z.string().min(1).max(MAX_JPEG_BASE64_CHARS),
    mimeType: z.literal('image/jpeg'),
    pagePath: z.string().max(200).regex(PAGE_PATH_RE, 'Must be a path starting with /'),
    /** Origin environment of the report, prepended to the Notion task title. */
    environment: z.enum(['LOCAL', 'DEV', 'PROD']),
  })
  .strip();

export type PortalBugReportInput = z.infer<typeof portalBugReportInputSchema>;
